import { HelpCategory } from './types';

export const categories: HelpCategory[] = [
  {
    categorySlug: 'getting-started',
    name: 'Getting Started',
    description: 'Learn the basics of HealioSpace',
    icon: 'rocket_launch',
    displayOrder: 1,
  },
  {
    categorySlug: 'clients',
    name: 'Managing Clients',
    description: 'Add, manage, and track your clients',
    icon: 'people',
    displayOrder: 2,
  },
  {
    categorySlug: 'appointments',
    name: 'Appointments & Scheduling',
    description: 'Schedule and manage appointments',
    icon: 'calendar_month',
    displayOrder: 3,
  },
  {
    categorySlug: 'messaging',
    name: 'Messaging',
    description: 'Secure messaging with clients',
    icon: 'chat',
    displayOrder: 4,
  },
  {
    categorySlug: 'telehealth',
    name: 'Telehealth',
    description: 'Video sessions and virtual care',
    icon: 'videocam',
    displayOrder: 5,
  },
  {
    categorySlug: 'content-tools',
    name: 'Content & Tools',
    description: 'Training programs, forms, recipes, and more',
    icon: 'extension',
    displayOrder: 6,
  },
  {
    categorySlug: 'billing',
    name: 'Billing & Subscriptions',
    description: 'Manage your subscription and billing',
    icon: 'payments',
    displayOrder: 7,
  },
  {
    categorySlug: 'settings-security',
    name: 'Settings & Security',
    description: 'Account settings, security, and preferences',
    icon: 'build',
    displayOrder: 8,
  },
];
